/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Line_Placeholder_NotesInputs */

const vi_stocktake_line_placeholder_notes = /** @type {(inputs: Stocktake_Line_Placeholder_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do lệch (tùy chọn)`)
};

/**

* @param {Stocktake_Line_Placeholder_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_line_placeholder_notes = /** @type {((inputs?: Stocktake_Line_Placeholder_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Line_Placeholder_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_line_placeholder_notes(inputs)
});